import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui'
import { cn } from '@/utils'

export interface EmptyStateProps {
  icon?: LucideIcon
  title: string
  description?: string
  /** Imperative action (legacy pages). Prefer `action` for custom nodes. */
  actionLabel?: string
  onAction?: () => void
  /** Custom action node (buttons, links). Takes precedence over actionLabel. */
  action?: ReactNode
  children?: ReactNode
  className?: string
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  action,
  children,
  className,
}: EmptyStateProps) {
  const resolvedAction =
    action !== undefined
      ? action
      : actionLabel && onAction
        ? (
            <Button className="mt-1" onClick={onAction}>
              {actionLabel}
            </Button>
          )
        : null

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed px-6 py-16 text-center mh-fade-in',
        className,
      )}
    >
      {Icon ? (
        <div className="bg-primary/10 text-primary flex size-12 items-center justify-center rounded-xl">
          <Icon className="size-6" aria-hidden />
        </div>
      ) : null}
      <div className="space-y-1">
        <h3 className="text-base font-semibold">{title}</h3>
        {description ? (
          <p className="text-muted-foreground max-w-sm text-sm">{description}</p>
        ) : null}
      </div>
      {resolvedAction}
      {children}
    </div>
  )
}
